import Emitter from "es6-event-emitter";
import APIManager from "./../utilities/apimanager";
import { createRedirectionLogoutUrl } from "./../utilities/utils";
import { LOGOUT_REDIRECTION } from "./../utilities/redirectorKeys";
// this class will implement al the necessary API communication
// and cookie management to authenticate users and authorize
// downloads. It does not implement any UI elements.
export default class SubScriptionManagerBase extends Emitter {
  _appState = null;
  _sessionManager = null;
  _cookieManager = null;
  _apiManager = null;
  _options = null;
  _subscriptionId = undefined;
  _authenticated = false;
  isFreePublication = false;

  // _authenticationPromiseData = {};
  // _authorizationPromiseData = {};
  // // note the description is purely internal, the errorcode needs to
  // // be translated in the translation files based on the code
  // _errors = {
  //   'E1': {
  //     code: 'E1',
  //     description: 'Can`t connect to server. Application only available for offline use.'
  //   },
  //   'E2': {
  //     code: 'E2',
  //     description: 'Can`t connect to server. Application only available for offline use.'
  //   },
  //   'E3': {
  //     code: 'E3',
  //     description: 'Fatal error. Connection with server impossible.'
  //   },
  //   'E4': {
  //     code: 'E4',
  //     description: 'Can`t connect to server. Application only available for offline use.'
  //   },
  //   'E5': {
  //     code: 'E5',
  //     description: 'You don`t have an active subscription, take a subscription for unlimited access.'
  //   },
  //   'E6': {
  //     code: 'E6',
  //     description: 'Your information is invalid. Try again or take a subscription for unlimited access.'
  //   },
  //   'E7': {
  //     code: 'E7',
  //     description: 'Password invalid. Check your password.'
  //   },
  //   'E8': {
  //     code: 'E8',
  //     description: 'Fatal error. Information can not be retrieved from the server.'
  //   },
  //   'E9': {
  //     code: 'E9',
  //     description: 'Fatal error. Information can not be retrieved from the server.'
  //   },
  //   'E10': {
  //     code: 'E10',
  //     description: 'Fatal error. Information can not be retrieved from the server.'
  //   },
  //   'E11': {
  //     code: 'E11',
  //     description: 'You have reached the maximum number of downloads with your subscription.'
  //   },
  //   'E12': {
  //     code: 'E12',
  //     description: 'Fatal error. Information can not be retrieved from the server.'
  //   },
  //   'E13': {
  //     code: 'E13',
  //     description: 'Fatal error. Information can not be retrieved from the server.'
  //   },
  //   'E14': {
  //     code: 'E14',
  //     description: 'There has been an error when verifying your credentials. Try again or contact our customer service.'
  //   },
  //   'E15': {
  //     code: 'E15',
  //     description: 'There has been an error when verifying your credentials. Try again or contact our customer service.'
  //   },
  //   'E16': {
  //     code: 'E16',
  //     description: 'Unexpected Error'
  //   },
  //   'E17': {
  //     code: 'E17',
  //     description: 'Unknown email address. Change it and try again'
  //   },
  //   'E18': {
  //     code: 'E18',
  //     description: 'An error has occurred when downloading your newspaper. Please try again or contact customer service.'
  //   },
  //   'E21': {
  //     code: 'E21',
  //     description: 'Subscription expired'
  //   },
  //   'E24': {
  //     code: 'E24',
  //     description: 'Subscription OK but not valid for this download'
  //   },
  //   'E100': {
  //     code: 'E100',
  //     description: 'Braintree Payment Gateway general error'
  //   },
  //   'E101': {
  //     code: 'E101',
  //     description: 'An account with the specified email already exists'
  //   },
  //   'E102': {
  //     code: 'E102',
  //     description: 'Either the account does not exist or the password is wrong'
  //   },
  //   'E103': {
  //     code: 'E103',
  //     description: 'This email is not associated with any account'
  //   },
  //   'NotAllowed': {
  //     code: 'Not_Allowed',
  //     description: 'Operation not allowed in this subscriptionmanager'
  //   },
  //   'Unknown': {
  //     code: 'Unknown_Error',
  //     description: 'Unknown Error occured'
  //   },
  //   'Session': {
  //     code: 'Session_error',
  //     description: 'No valid session'
  //   },
  //   'InvalidInformation': {
  //     code: 'Invalid_information_error',
  //     description: 'The information is not vallid.'
  //   }
  // }

  constructor(
    appState,
    sessionManager,
    apiManager,
    cookieManager,
    options = {}
  ) {
    super();
    this._appState = appState;
    this._sessionManager = sessionManager;
    this._apiManager = apiManager;
    this._cookieManager = cookieManager;
    this._options = options;
    // check the cookie for authentication and set the status.

    //set UUID
    this._appState.uuid = this._sessionManager.UUID;
  }

  // Returns the current authentication state.
  get isAuthenticated() {
    return this._authenticated;
  }

  // returns a promise that will either reject with an error code when authentication
  // fails, either resolves to success
  // in any case it will also trigger the authenticationstatuschanged event.
  authenticateByUserNamePassword(username, password) {
    const authenticationPromise = new Promise((resolve, reject) => {
      // check if there is an SSO cookie if the settings are SSO enabled,
      // else check for the subscription cookie.
      this._authenticated =
        username === "test@twipemobile.com" && password === "test";
      if (this._authenticated) {
        this.trigger("subscriptionmanager:authenticationstatuschanged");
        resolve();
      } else {
        this.trigger("subscriptionmanager:authenticationstatuschanged");
        //TODO: right error
        reject("not authenticated");
      }
    });
    return authenticationPromise;
  }

  // returns a promise that will either reject with an error code when authentication
  // fails, either resolves to success. This is to be used in case of SSO, or
  // to check if you are autenticated
  // in any case it will also trigger the authenticationstatuschanged event if
  // the current status changed.
  // eslint-disable-next-line
  authenticate(downloadToken) {
    const authenticationPromise = new Promise((resolve) => {
      // check if there is an SSO cookie if the settings are SSO enabled,
      // else check for the subscription cookie.
      this._authenticated = true;
      this.trigger("subscriptionmanager:authenticationstatuschanged");
      resolve();
    });
    return authenticationPromise;
  }

  // returns a promise that will either reject with an error code when authorization
  // fails, either resolves to success. It will also execute the authentication
  // if not yet authenticated. It will also potentially triger the
  // authenticationstatuschanged event
  authorize(
    publicationData = {
      contentPackageId: -1,
      publicationId: -1,
      price: -1,
    }
  ) {
    const authorizationPromise = new Promise((resolve, reject) => {
      this._appState.isFreePublication =
        publicationData && publicationData.price === 0;
      if (publicationData.price !== 0) {
        this.authenticate()
          .then(() => {
            if (
              publicationData &&
              publicationData.contentPackageId &&
              publicationData.contentPackageId === 513887
            ) {
              // call Authorization methods and return the promises
              resolve();
            } else {
              // for testing now resolve false
              reject("error: no rights");
            }
          })
          .catch((error) => {
            // something went wrong reject it.
            reject(error);
          });
      } else {
        // 0 priced publications are always authorized
        resolve();
      }
    });
    return authorizationPromise;
  }

  authorizeArticle(contentPackageId, publicationId, pageId, contentItemId) {
    if (this._authenticated) {
      return true;
    } else {
      if (this.isFreePublication) {
        return true;
      }
      if (this._appState.socialSharing) {
        if (this._appState.socialSharingReset === "session") {
          if (this._appState.viewedArticles.indexOf(contentItemId) >= 0) {
            return true;
          } else if (
            this._appState.viewedArticles.length <
            this._appState.socialSharingNumberOfArticles
          ) {
            this._appState.viewedArticles.push(contentItemId);
            return true;
          } else if (
            this._appState.viewedArticles.length ==
            this._appState.socialSharingNumberOfArticles
          ) {
            if (parent) {
              parent.postMessage(
                {
                  MessageName: "SHARING_LIMIT_REACHED",
                  SharingFreemiumLimit:
                    this._appState.socialSharingNumberOfArticles,
                  SocialSharingReset: this._appState.socialSharingReset,
                  Url: window.location.href,
                },
                "*"
              );
            }
            return false;
          } else {
            return false;
          }
        } else if (this._appState.socialSharingReset === "contentpackage") {
          if (
            typeof Storage !== "undefined" &&
            this._appState.socialSharingNumberOfArticles > 0
          ) {
            let item = JSON.parse(
              localStorage.getItem(contentPackageId.toString())
            );
            if (!item) {
              item = {};
            }
            if (item[contentItemId.toString()]) {
              return true;
            } else if (
              Object.keys(item).length <
              this._appState.socialSharingNumberOfArticles
            ) {
              item[contentItemId.toString()] = true;
              localStorage.setItem(
                contentPackageId.toString(),
                JSON.stringify(item)
              );
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        } else if (this._appState.socialSharingReset === "week") {
          if (
            typeof Storage !== "undefined" &&
            this._appState.socialSharingNumberOfArticles > 0
          ) {
            let item = JSON.parse(localStorage.getItem("contentItemsWeek"));
            if (item && item["items"]) {
              const items = item["items"];
              if (items[contentItemId.toString()]) {
                return true;
              } else if (
                Object.keys(items).length <
                this._appState.socialSharingNumberOfArticles
              ) {
                items[contentItemId.toString()] = true;
                localStorage.setItem("contentItemsWeek", JSON.stringify(item));
                return true;
              } else {
                return false;
              }
            }
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  }

  // returns a promise that will either reject with an error code when authorization
  // fails, either resolves to success. It will tagke as the assumption that
  // the CP and Publication is authorized and only uses the pageId for freemium
  // and metered model implementations
  // eslint-disable-next-line
  authorizePage(contentPackageId, publicationId, pageId) {
    if (
      this._appState.isNextgenSharing() &&
      !this.authorizeArticle(
        contentPackageId,
        publicationId,
        pageId,
        `${contentPackageId}_${pageId}`
      )
    ) {
      return Promise.reject(false);
    }
    return Promise.resolve(true);
  }

  // delete the subscriptionCookie and fire event if authenticationstatuschanged
  logOut() {
    const promise = new Promise((resolve, reject) => {
      if (this._options.paywallRedirectionUrl) {
        APIManager.getUserProfileValue(LOGOUT_REDIRECTION)
          .then((result) => {
            this.removeAuthenticationCookies();
            if (result && result[0] && result[0].Value) {
              window.top.location.href = createRedirectionLogoutUrl(
                result[0].Value
              );
            } else {
              this.removeAuthenticationCookies();
              reject();
            }
            resolve();
          })
          .catch(() => {
            this.removeAuthenticationCookies();
            reject();
          });
      } else {
        this.removeAuthenticationCookies();
      }
    });
    return promise;
  }

  removeAuthenticationCookies() {
    if (this._authenticated) {
      this._cookieManager.removeCookie(
        this._cookieManager.cookieKeys.REDIRECTIONS
      );
      this._authenticated = false;
      this._deleteSubscriptionCookie();
      this._deleteReaderSessionCookie();
      this.trigger("subscriptionmanager:authenticationstatuschanged");
    }
  }

  _deleteSubscriptionCookie() {
    this._cookieManager.removeCookie(this._cookieManager.cookieKeys.LOGIN);
    this._appState.loginInformation = null;
  }

  _deleteReaderSessionCookie() {
    this._cookieManager.removeCookie(
      this._cookieManager.cookieKeys.READER_SESSION
    );
  }

  _setLoginInformationFromCookie() {
    const cookie = this._cookieManager.getCookie(
      this._cookieManager.cookieKeys.LOGIN
    );
    if (cookie) {
      const {
        subscriptionReference,
        subscriptionUserReference,
        userSubscriptionType,
      } = JSON.parse(cookie);
      this._appState.setUserInfo({
        subscriptionReference,
        subscriptionUserReference,
        userSubscriptionType,
      });
    }
  }

  _createSubscriptionCookie(
    subsId,
    subscriptionReference,
    subscriptionUserReference,
    userSubscriptionType,
    userName
  ) {
    this._appState.setUserInfo({
      subscriptionReference,
      subscriptionUserReference,
      userSubscriptionType,
    });
    const info = {
      subsId,
      subscriptionReference,
      subscriptionUserReference,
      userSubscriptionType,
    };
    if (userName) {
      info.userName = userName;
    }

    this._cookieManager.createCookie(
      this._cookieManager.cookieKeys.LOGIN,
      JSON.stringify(info)
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/subscriptionmanagement/subscriptionmanagerbase.js